/**
 * Copyright (c) HashiCorp, Inc.
 */

import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { fn, hash } from '@ember/helper';

import type { ComponentLike } from '@glint/template';
import type { HdsDropdownListItemCheckboxSignature } from '@hashicorp/design-system-components/components/hds/dropdown/list-item/checkbox';
import type { FilterConfig, ToggleArgs } from '../../filter-bar';

export interface FilterBarFilterCheckboxSignature {
  Args: {
    checkbox?: ComponentLike<HdsDropdownListItemCheckboxSignature>;
    filterName: string;
    name: string;
    value?: unknown;
    localConfig?: FilterConfig;
    toggle: (toggle: ToggleArgs) => void;
    isChecked: (
      localConfig: FilterConfig,
      name: string,
      value: unknown,
    ) => boolean;
    isMultiSelect?: boolean;
  };
  Blocks: {
    default: [];
  };

  Element: HdsDropdownListItemCheckboxSignature['Element'];
}

export default class Checkbox extends Component<FilterBarFilterCheckboxSignature> {
  get isChecked() {
    return this.args.isChecked?.(
      this.args.localConfig ?? {},
      this.args.filterName,
      this.args.value,
    );
  }

  <template>
    {{#let @checkbox as |Checkbox|}}
      <Checkbox
        checked={{this.isChecked}}
        {{on
          "click"
          (fn
            @toggle
            (hash
              filterName=@filterName
              text=@name
              value=@value
              isMultiSelect=@isMultiSelect
            )
          )
        }}
        ...attributes
      >
        {{#if (has-block)}}
          {{yield}}
        {{else}}
          {{@name}}
        {{/if}}
      </Checkbox>
    {{/let}}
  </template>
}
